module.exports = __webpack_public_path__ + "static/media/TWI logo_white.0490ddbf.svg";